export const saveNewAdmissionsCycleMutation = `mutation SaveNewAdmissionsCycle($input: AdmissionsCycleInput!) {
    saveNewAdmissionsCycle(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`;